(() => {
  const closeLabel = document.currentScript.dataset.closeLabel;
  const boundInputs = new WeakSet();
  const boundClosers = new WeakSet();
  const boundDialogs = new WeakSet();
  let sequence = 0;
  const closeDialog = (control) => control.dispatchEvent(new MouseEvent('click', { bubbles: true }));
  const enhanceDialog = (dialog) => {
    const title = dialog.querySelector('.restock-alerts-form-title');
    if (title) {
      if (!title.id) title.id = 'willowybe-restock-title-' + (++sequence);
      dialog.setAttribute('aria-labelledby', title.id);
    }
    const input = dialog.querySelector('.restock-alerts-email-input');
    if (input) {
      if (!input.id) input.id = 'willowybe-restock-email-' + (++sequence);
      input.type = 'email';
      input.inputMode = 'email';
      input.autocomplete = 'email';
      input.setAttribute('autocapitalize', 'off');
      const label = dialog.querySelector('.restock-alerts-email-label');
      if (label) label.setAttribute('for', input.id);
      if (!boundInputs.has(input)) {
        boundInputs.add(input);
        input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' && !event.isComposing && !event.repeat) {
            event.preventDefault();
            const submit = dialog.querySelector('.restock-alerts-submit-button');
            if (submit && !submit.disabled) submit.click();
          }
        });
      }
    }
    const closer = dialog.querySelector('.modal-close-btn');
    if (closer) {
      closer.setAttribute('role', 'button');
      closer.setAttribute('tabindex', '0');
      closer.setAttribute('focusable', 'true');
      closer.setAttribute('aria-label', closeLabel);
      closer.style.setProperty('width', '44px', 'important');
      closer.style.setProperty('height', '44px', 'important');
      closer.style.setProperty('top', '4px', 'important');
      closer.style.setProperty('right', '4px', 'important');
      if (!boundClosers.has(closer)) {
        boundClosers.add(closer);
        closer.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            closeDialog(closer);
          }
        });
      }
      if (!boundDialogs.has(dialog)) {
        boundDialogs.add(dialog);
        dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          const currentCloser = dialog.querySelector('.modal-close-btn');
          if (currentCloser) closeDialog(currentCloser);
        });
      }
    }
  };
  const enhance = (root) => {
    if (!(root instanceof Element)) return;
    const dialog = root.closest('.nm-top-layer-dialog');
    if (dialog) enhanceDialog(dialog);
    root.querySelectorAll('.nm-top-layer-dialog').forEach(enhanceDialog);
    const toasts = root.matches('.restock-alerts-toast') ? [root] : root.querySelectorAll('.restock-alerts-toast');
    toasts.forEach((toast) => {
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
    });
  };
  enhance(document.body);
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) enhance(node);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();